module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Honey_HK.fa5cd5f6.png";